var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWidgetStack18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1zM14 5v4a1 1 0 1 1-2 0V5a1 1 0 1 1 2 0zM10 8V5a1 1 0 0 0-2 0v3a1 1 0 1 0 2 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 4a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4zm4-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik01IDRhMSAxIDAgMCAxIDEgMXY2YTEgMSAwIDEgMS0yIDBWNWExIDEgMCAwIDEgMS0xek0xNCA1djRhMSAxIDAgMSAxLTIgMFY1YTEgMSAwIDEgMSAyIDB6TTEwIDhWNWExIDEgMCAwIDAtMiAwdjNhMSAxIDAgMSAwIDIgMHoiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDRhNCA0IDAgMCAxIDQtNGgxMGE0IDQgMCAwIDEgNCA0djEwYTQgNCAwIDAgMS00IDRINGE0IDQgMCAwIDEtNC00VjR6bTQtMmgxMGEyIDIgMCAwIDEgMiAydjEwYTIgMiAwIDAgMS0yIDJINGEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMnoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgWidgetStack18 as ReactComponent };